import { Component } from "react";
import { Box, Flex } from "@chakra-ui/react";
import Card from "./Card";
import DirectionButton from "./DirectionButton";
import updateStationList from "./updateStationList";
import NavigationButtons from "src/components/NavigationButtons";

export default class StationPicker extends Component {
  state = {
    stations: [],
    currentIndex: 0
  };
  static getDerivedStateFromProps(props, state) {
    if (state.stations === props.stations) {
      return null;
    }
    const updatedList = updateStationList(state.stations, props.stations);
    const newMaxIndex = updatedList.length - 1;
    return {
      stations: updatedList,
      currentIndex:
        newMaxIndex < state.currentIndex ? newMaxIndex : state.currentIndex
    };
  }
  componentDidMount = () => {
    const { stations } = this.state;
    const { previousBabyStation } = this.props;

    // display previously monitored baby station as first station
    if (previousBabyStation) {
      const previousBabyStationIndex = stations.findIndex((station) => {
        return station.jid === previousBabyStation.jid;
      });
      if (previousBabyStationIndex >= 0) {
        this.setState({ currentIndex: previousBabyStationIndex });
      }
    }

    window.addEventListener("keydown", this.handleKeyDown);
    window.addEventListener("wheel", this.handleWheel);
  };

  componentWillUnmount = () => {
    window.removeEventListener("keydown", this.handleKeyDown);
    window.removeEventListener("wheel", this.handleWheel);
  };
  handleKeyDown = ({ key }) => {
    if (key === "ArrowLeft") {
      this.onPrevious();
    } else if (key === "ArrowRight") {
      this.onNext();
    }
  };
  handleWheel = ({ deltaY }) => {
    if (deltaY < 0) {
      this.onPrevious();
    } else if (deltaY > 0) {
      this.onNext();
    }
  };

  onNext = () => {
    const { isConnecting } = this.props;
    if (isConnecting) return;

    this.setState(({ currentIndex, stations }) => ({
      currentIndex:
        currentIndex === stations.length - 1 ? currentIndex : currentIndex + 1
    }));
  };
  onPrevious = () => {
    const { isConnecting } = this.props;
    if (isConnecting) return;

    this.setState(({ currentIndex }) => ({
      currentIndex: currentIndex === 0 ? 0 : currentIndex - 1
    }));
  };

  render() {
    const { stations, currentIndex } = this.state;
    const { onConnect, familyName, isConnecting, isInModal } = this.props;

    const disableNext = isConnecting || currentIndex === stations.length - 1;
    const disablePrevious = isConnecting || currentIndex === 0;
    const showNavigation = stations.length > 1;

    return (
      <>
        {!isConnecting && !isInModal && (
          <NavigationButtons
            mode="fullScreen"
            onBack={({ navigate }) => navigate("/dashboard")}
          />
        )}
        <Flex
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          pt="8px"
          height="100%"
        >
          <Flex justifyContent="center" alignItems="center">
            {showNavigation && (
              <DirectionButton
                mr="64px"
                type="previous"
                disabled={disablePrevious}
                onClick={this.onPrevious}
              />
            )}
            <Card
              station={stations[currentIndex]}
              onConnect={onConnect}
              myFamilyName={familyName}
              isConnecting={isConnecting}
              isInModal={isInModal}
            />
            {showNavigation && (
              <DirectionButton
                ml="64px"
                type="next"
                disabled={disableNext}
                onClick={this.onNext}
              />
            )}
          </Flex>
          <Flex mt="32px">
            {showNavigation &&
              stations.map((station, id) => (
                <Box
                  key={station.jid}
                  borderRadius="100%"
                  width="7px"
                  height="7px"
                  mr="6px"
                  bg={
                    id === currentIndex
                      ? "rgba(0, 0, 0, 0.38)"
                      : "rgba(0, 0, 0, 0.08)"
                  }
                  sx={{
                    ":last-of-type": {
                      mr: 0
                    }
                  }}
                />
              ))}
          </Flex>
        </Flex>
      </>
    );
  }
}
